import { API_URL } from "config";
import Http from "util/https";
import { OrderSupplier, OrderSupplierResponse, OrderSupplierResponseApi, SearchSupplierApiParams } from "../types";
import { convertUTCToDate, orderStatusFromNumber } from "../utils/common";


// const res: {data: OrderSupplierResponseApi} = {data: {
//   total: 15,
//   contract_infos: [{
//     order_status: 5,
//     is_downloaded: false,
//     order_no: "0123456789012",
//     item_cd: "000001",
//     jan_cd: "1234567890123",
//     brand: "WH",
//     item_name: "WH STA",
//     size: "185/65R15H",
//     maker_item_cd: "-",
//     order_quantity: 1000,
//     unit_base_price: 10000,
//     order_date: "2025-03-03",
//     desired_date: "2025-04-04",
//     shipping_date: "2025-04-02",
//     shipping_scheduled: "2025-04-03",
//     arrival_date: "2025-04-01",
//     shipping_dest_zip: "000-0000",
//     shipping_dest_address: "埼玉県戸田市美女木北２－１－１７",
//     shipping_dest_tel: "000-0000-0000",
//     shipping_dest_name: "美女木店",
//     shipping_company: "ヤマト運輸",
//     shipping_no: "1234567890123",
//     memo: "店舗メモです",
//     remarks: "本部メモです"
//   }],
// }};

// const oList: OrderSupplierResponse[] = res.data.contract_infos.map((o, i) => {
//   const order = structuredClone(o)
//   order.order_no = [`${i}`.padStart(4, '0'), order.order_no.split('_')[1]].join('_');
//   return order;
// })
// res.data.contract_infos = oList;

/**
 * 仕入先・外部倉庫用注文商品一覧Api
 * @param params 注文商品一覧Apiのパラメータ
 * @returns orderList
 */
export default async function orderSupplierListApi(params: SearchSupplierApiParams) {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/order/contract/select`;
  const res = await http.post<OrderSupplierResponseApi>(url, params);
  console.log(res);

  const orderList: OrderSupplier[] = res.data.contract_infos.map((o, i) => ({
    id: (params.offset ?? 0) + i+1,
    selected: false,
    orderNumber: o.order_no ?? '',
    productCd: o.item_cd ?? '',
    janCd: o.jan_cd ?? '',
    orderStatus: orderStatusFromNumber(o.order_status),
    brand: o.brand_name ?? '',
    productName: o.item_name ?? '',
    size: o.size ?? '',
    productNumber: o.maker_item_cd ?? '',
    orderCount: o.order_quantity || 0,
    shippingCount: o.shipping_quantity || 0,
    headquartersCost: (o.order_quantity * o.unit_base_price) || 0,
    headquartersUnitCost: o.unit_base_price || 0,
    orderDate: convertUTCToDate(o.order_date),
    deliveryDate: convertUTCToDate(o.desired_date),
    shippingDate: convertUTCToDate(o.shipping_date),
    expectedShippingDate: convertUTCToDate(o.shipping_scheduled),
    arrivalDate: o.arrival_date,
    shopRemarks: o.memo ?? '',
    csvDownloaded: o.is_downloaded ?? false,
    destinationName: o.shipping_dest_name ?? '',
    shippingCompanyName: o.shipping_company ?? '',
    trackingNumber: o.shipping_no ?? '',
    changedShippingDate: "",
    changedExpectedShippingDate: "",
    changedArrivalDate: "",
    changedShippingCompanyName: "",
    changedTrackingNumber: "",
    changedShippingStatus: "",
    postalCd: o.shipping_dest_zip ?? '',
    destinationAddress: o.shipping_dest_address ?? '',
    phoneNumber: o.shipping_dest_tel ?? '',
  }));

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});
  // return res.data;
  return {
    total: res.data.total,
    orders: orderList
  };
}